import { faAngleUp, faAngleDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import { get } from "lodash";
import React from "react";
import { FieldInputDollar, FieldInputDollarBox } from "../Forms";

const filterOutNan = (value) =>
  !isNaN(value) ? parseFloat(value).toFixed(2) : "-";

const WithdrawalExpandableCard = ({
  headerData,
  setIsExpandable,
  isExpandable,
  children,
  className,
  style = {},
  isCustomSource,
  values,
  setFieldValue,
  handleChange,
}) => {
  const allocationAmount = get(
    values,
    headerData.fieldNameForSpecificSourceAllocation,
    ""
  );
  console.log("headerData", headerData);
  return (
    <div
      style={style}
      className={`withdrawalExpandableCard_layout  mt-2 ${className}`}
    >
      <div className="d-flex justify-content-space-between w-100">
        <FontAwesomeIcon
          icon={isExpandable ? faAngleUp : faAngleDown}
          size="lg"
          className="mt-2 ml-2"
          onClick={() => {
            setIsExpandable(!isExpandable);
          }}
        />
        <div className="d-flex flex-col">
          <span className="ft-12 withdrawalTextColor">Source Name</span>
          <span className="ft-14">{headerData.sourceName}</span>
        </div>

        <div className="d-flex flex-col">
          <span className="ft-12 withdrawalTextColor">Available Amount</span>
          <span className="ft-14">
            {filterOutNan(headerData.availableAmount)}
          </span>
        </div>

        <div className="d-flex flex-col">
          <span className="ft-12 withdrawalTextColor">Gross Withdrawal</span>
          <span className="ft-14">
            {filterOutNan(headerData.grossWithdrawal)}
          </span>
        </div>

        <div className="d-flex flex-col mw-25">
          <span className="ft-12 withdrawalTextColor">Net Withdrawal</span>
          <span className="ft-14">
            {isCustomSource ? (
              <Field
                size="xs"
                isRequired
                name={headerData.fieldNameForSpecificSourceAllocation}
                type="text"
                autoComplete="off"
                preventNegative={true}
                value={allocationAmount}
                precision={2}
                // max={headerData.maximumWithdrawableAmount}
                onChange={headerData.onSourceAllocationAmountChange}
                validate={(value) => {
                  return [undefined, null, ""].includes(allocationAmount)
                    ? "Required"
                    : parseFloat(headerData.availableAmount.toFixed(2)) <
                      parseFloat(headerData.grossWithdrawal.toFixed(2))
                    ? "Gross withdrawal amount cannot be greater than available amount"
                    : undefined;
                }}
                component={FieldInputDollar}
              />
            ) : (
              filterOutNan(headerData.netWithdrawal)
            )}
          </span>
        </div>
      </div>

      {isExpandable && children}
    </div>
  );
};

export default WithdrawalExpandableCard;
